"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMarginAlertActions = void 0;
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _reactRedux = require("react-redux");
var _selectors = require("../../../redux/margin/selectors");
var _userActions = require("../../../redux/actions/userActions");
var _actions = require("../../../redux/margin/actions");
/**
 *
 * @param {import('./MarginAlert').MarginNotificationType} item
 */
var useMarginAlertActions = exports.useMarginAlertActions = function useMarginAlertActions(item) {
  var dispatch = (0, _reactRedux.useDispatch)();
  var store = (0, _reactRedux.useStore)();
  var _useHistory = (0, _reactRouterDom.useHistory)(),
    push = _useHistory.push;
  var dismiss = (0, _react.useCallback)(function () {
    return dispatch((0, _actions.dismissMarginNotification)(item.id));
  }, [dispatch, item.id]);
  var viewActivity = (0, _react.useCallback)(function () {
    var state = store.getState();
    var marginAccount = (0, _selectors.marginAccountSelector)(state);
    var selectedAccountId = (0, _selectors.selectedAccountIdSelector)(state);
    if (marginAccount && selectedAccountId !== marginAccount.AccountId) {
      dispatch((0, _userActions.selectAccount)(marginAccount.AccountId, marginAccount.OMSID));
    }
    push('/exchange/margin', {
      historyTableIndex: item.type === 'MarginCall' ? 3 /* Positions Tab */ : 4 /* Position History Tab */
    });
  }, [store, push, item.type, dispatch]);
  return {
    dismiss: dismiss,
    viewActivity: viewActivity
  };
};